import {
  Alert,
  Card,
  Col,
  Collapse,
  Descriptions,
  Row,
  Space,
  Statistic,
  Tag,
  Typography,
} from "antd";
import { FareSimulationResponse } from "../../shared/dtos/internationalPricingDTO";

const { Text } = Typography;

const SimulationResult = ({ result }: { result: FareSimulationResponse }) => (
  <Card className="simulation-result">
    <Row gutter={[24, 16]} align="middle">
      <Col xs={24} md={8}>
        <Statistic
          title="Tarifa final"
          value={result.fare}
          precision={2}
          prefix={result.currency}
        />
      </Col>
      <Col xs={24} md={10}>
        <Text type="secondary">Ubicación coincidente</Text>
        <div>
          <Text strong>
            {result.matchedLocation
              ? `${result.matchedLocation.city}, ${result.matchedLocation.country}`
              : "Sin ciudad configurada"}
          </Text>
        </div>
      </Col>
      <Col xs={24} md={6}>
        <Tag color={result.source === "city_pricing" ? "green" : "blue"}>
          {result.source === "city_pricing"
            ? "Tarifa de ciudad"
            : "Estimación con IA"}
        </Tag>
      </Col>
    </Row>

    {result.warnings.map((warning) => (
      <Alert key={warning} type="warning" showIcon message={warning} />
    ))}

    <Collapse
      ghost
      items={[
        {
          key: "breakdown",
          label: "Ver desglose",
          children: (
            <Space direction="vertical" size="middle">
              <Descriptions
                bordered
                size="small"
                column={{ xs: 1, sm: 2, lg: 4 }}
                items={[
                  {
                    key: "effectiveKm",
                    label: "KM efectivos",
                    children: result.effectiveKm,
                  },
                  {
                    key: "pricePerKm",
                    label: "Precio por KM",
                    children: result.rates.pricePerKm,
                  },
                  {
                    key: "minimumFare",
                    label: "Tarifa mínima",
                    children: result.rates.minimumFare,
                  },
                  {
                    key: "minimumCharge",
                    label: "Cobro mínimo",
                    children: result.rates.minimumCharge,
                  },
                ]}
              />
              <Descriptions
                bordered
                size="small"
                column={{ xs: 1, sm: 2, lg: 4 }}
                items={[
                  {
                    key: "company",
                    label: "Multiplicador empresa",
                    children: `${result.markups.adminPercentage}%`,
                  },
                  {
                    key: "service",
                    label: "Multiplicador servicio",
                    children: `${result.markups.serviceInternationalPercentage}%`,
                  },
                  {
                    key: "tier",
                    label: "Multiplicador tier",
                    children: `${result.markups.tierPercentage}%`,
                  },
                  {
                    key: "quantity",
                    label: "Vehículos",
                    children: result.markups.quantity,
                  },
                ]}
              />
            </Space>
          ),
        },
      ]}
    />
  </Card>
);

export default SimulationResult;
